export const OrgTypeNames = [ '未知', '其他企业', '绩效咨询企业', '政府财政预算单位', '政府财政局' ];
export const ReadStateNames = [ '未读', '已读' ];
export const EditStateNames = [ '未编辑', '已读未编辑', '已编辑' ];
export const ApplyStateNames = [ '申请中', '已拒绝', '已同意' ];
